const RecentIcon = ({ size = 24, color = 'currentColor', ...props }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M9.66184 19.5423C8.67137 19.192 7.7596 18.6501 6.97857 17.9474C6.19755 17.2448 5.56256 16.3952 5.10988 15.4471C4.65719 14.4991 4.39567 13.4712 4.34024 12.4221C4.28482 11.373 4.43657 10.3232 4.78684 9.33273C5.13711 8.34227 5.67904 7.4305 6.38168 6.64947C7.08432 5.86844 7.93392 5.23346 8.88196 4.78077C9.83 4.32809 10.8579 4.06657 11.907 4.01114C12.9561 3.95571 14.0059 4.10747 14.9964 4.45774C15.9868 4.80801 16.8986 5.34994 17.6796 6.05258C18.4607 6.75522 19.0956 7.60482 19.5483 8.55286C20.001 9.5009 20.2625 10.5288 20.318 11.5779C20.3734 12.627 20.2216 13.6768 19.8714 14.6673C19.5211 15.6577 18.9792 16.5695 18.2765 17.3505C17.5739 18.1316 16.7243 18.7665 15.7762 19.2192C14.8282 19.6719 13.8003 19.9334 12.7512 19.9889C11.7021 20.0443 10.6523 19.8925 9.66183 19.5423L9.66184 19.5423Z"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.5 8.5V11.9534C12.5 12.3321 12.286 12.6784 11.9472 12.8478L9.5 14.0714"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default RecentIcon
